import React, { ReactNode } from "react"
import DialogContent from "@mui/material/DialogContent"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import CommonHeader from "components/common/CommonHeader"
import ModalDefault from "components/Modal/ModalDefault"
import CommonFooter from "components/common/CommonFooter"
import styles from "./Layout.module.scss"

interface Props {
  closeModal: () => void
  innerContents: ReactNode
  children: ReactNode
  openModal: boolean
}
/**
 * レイアウト（外枠）のコンポーネント
 * ヘッダー・フッターを含む画面の外枠を作る要素
 * ※モーダルを利用する場合は「LayoutWithModal」利用
 * @param {() => void} closeModal - モーダルを閉じるボタン押下時の処理
 * @param {ReactNode} innerContents - 表示対象のモーダル（/src/components/Modal以下）を設定
 * @param {ReactNode} children - 小要素（画面の内側の要素）
 * @param {boolean} openModal - モーダルの表示・非表示
 */
const LayoutWithModal = ({ closeModal, innerContents = <ModalDefault />, children, openModal }: Props) => {
  return (
    <div className={styles.root}>
      <CommonHeader />
      <div className={styles.contents}>{children}</div>
      <CommonFooter />
      <Dialog
        open={openModal}
        keepMounted
        onClose={closeModal}
        aria-labelledby="common-dialog-title"
        aria-describedby="common-dialog-description"
        className={styles.dialog}
      >
        <IconButton className={styles.buttonCloseRight} onClick={closeModal}>
          <CloseIcon />
        </IconButton>
        <DialogContent className={styles.dialogContent}>{innerContents}</DialogContent>
        <DialogActions className={styles.dialogForm}>
          <IconButton className={styles.buttonCloseBottom} onClick={closeModal}>
            <span>
              <CloseIcon />
              閉じる
            </span>
          </IconButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default LayoutWithModal
